module.exports = __webpack_public_path__ + "img/ics_f_thumb-good.37561bfa.svg";